'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cc = require('classcat');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cc__default = /*#__PURE__*/_interopDefaultLegacy(cc);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "@keyframes react-typography_1-3-2_wave {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 600px 0;\n  }\n}\n.react-typography_1-3-2_co-heading {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  font-family: var(--font-family);\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--1 {\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 40px;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--2 {\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 32px;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--3 {\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 28px;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--4 {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 24px;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--5 {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--6 {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--truncated {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n@keyframes react-typography_1-3-2_wave {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 600px 0;\n  }\n}\n.react-typography_1-3-2_co-text {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  font-family: var(--font-family);\n  color: inherit;\n}\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--small {\n  font-size: var(--font-size-small);\n  line-height: 16px;\n}\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--medium, .react-typography_1-3-2_co-text {\n  font-size: var(--font-size-base);\n  line-height: 20px;\n}\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--weight-light {\n  font-weight: 300;\n}\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--weight-regular, .react-typography_1-3-2_co-text {\n  font-weight: 400;\n}\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--weight-medium {\n  font-weight: 500;\n}\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--weight-inherit {\n  font-weight: inherit;\n}\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--truncated {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.react-typography_1-3-2_co-mark {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  border-radius: 4px;\n  box-shadow: inset 0 0 0 0.25ch var(--mark-color), 0 0 0 0.25ch var(--mark-color);\n  color: var(--gray-800);\n  background-color: var(--mark-color);\n}\n\n.react-typography_1-3-2_co-mark.react-typography_1-3-2_co-mark--yellow, .react-typography_1-3-2_co-mark {\n  --mark-color: var(--yellow-500);\n}\n.react-typography_1-3-2_co-mark.react-typography_1-3-2_co-mark--light-yellow {\n  --mark-color: var(--yellow-400);\n}\n\n@keyframes react-typography_1-3-2_wave {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 600px 0;\n  }\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--skeleton {\n  background-color: var(--gray-300);\n  border-radius: 4px;\n  font-size: 0;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--animated-skeleton {\n  animation: react-typography_1-3-2_wave 1s infinite linear;\n  background: linear-gradient(to right, var(--gray-200) 0%, var(--gray-300) 40%, var(--gray-200) 60%);\n  background-size: 600px;\n  border-radius: 4px;\n  font-size: 0;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--1.react-typography_1-3-2_co-heading--skeleton, .react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--1.react-typography_1-3-2_co-heading--animated-skeleton {\n  height: 40px;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--2.react-typography_1-3-2_co-heading--skeleton, .react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--2.react-typography_1-3-2_co-heading--animated-skeleton {\n  height: 32px;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--3.react-typography_1-3-2_co-heading--skeleton, .react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--3.react-typography_1-3-2_co-heading--animated-skeleton {\n  height: 28px;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--4.react-typography_1-3-2_co-heading--skeleton, .react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--4.react-typography_1-3-2_co-heading--animated-skeleton {\n  height: 24px;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--5.react-typography_1-3-2_co-heading--skeleton, .react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--5.react-typography_1-3-2_co-heading--animated-skeleton {\n  height: 14px;\n}\n.react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--6.react-typography_1-3-2_co-heading--skeleton, .react-typography_1-3-2_co-heading.react-typography_1-3-2_co-heading--6.react-typography_1-3-2_co-heading--animated-skeleton {\n  height: 12px;\n}\n\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--skeleton {\n  background-color: var(--gray-300);\n  border-radius: 4px;\n  font-size: 0;\n}\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--animated-skeleton {\n  animation: react-typography_1-3-2_wave 1s infinite linear;\n  background: linear-gradient(to right, var(--gray-200) 0%, var(--gray-300) 40%, var(--gray-200) 60%);\n  background-size: 600px;\n  border-radius: 4px;\n  font-size: 0;\n}\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--skeleton + .react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--skeleton, .react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--animated-skeleton + .react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--animated-skeleton {\n  margin-top: var(--base-spacing, 4px);\n}\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--small.react-typography_1-3-2_co-text--skeleton, .react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--small.react-typography_1-3-2_co-text--animated-skeleton {\n  height: 16px;\n}\n.react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--medium.react-typography_1-3-2_co-text--skeleton, .react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--skeleton, .react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--medium.react-typography_1-3-2_co-text--animated-skeleton, .react-typography_1-3-2_co-text.react-typography_1-3-2_co-text--animated-skeleton {\n  height: 20px;\n}";
var styles = {
  "co-heading": "react-typography_1-3-2_co-heading",
  "co-heading--1": "react-typography_1-3-2_co-heading--1",
  "co-heading--2": "react-typography_1-3-2_co-heading--2",
  "co-heading--3": "react-typography_1-3-2_co-heading--3",
  "co-heading--4": "react-typography_1-3-2_co-heading--4",
  "co-heading--5": "react-typography_1-3-2_co-heading--5",
  "co-heading--6": "react-typography_1-3-2_co-heading--6",
  "co-heading--truncated": "react-typography_1-3-2_co-heading--truncated",
  "co-text": "react-typography_1-3-2_co-text",
  "co-text--small": "react-typography_1-3-2_co-text--small",
  "co-text--medium": "react-typography_1-3-2_co-text--medium",
  "co-text--weight-light": "react-typography_1-3-2_co-text--weight-light",
  "co-text--weight-regular": "react-typography_1-3-2_co-text--weight-regular",
  "co-text--weight-medium": "react-typography_1-3-2_co-text--weight-medium",
  "co-text--weight-inherit": "react-typography_1-3-2_co-text--weight-inherit",
  "co-text--truncated": "react-typography_1-3-2_co-text--truncated",
  "co-mark": "react-typography_1-3-2_co-mark",
  "co-mark--yellow": "react-typography_1-3-2_co-mark--yellow",
  "co-mark--light-yellow": "react-typography_1-3-2_co-mark--light-yellow",
  "co-heading--skeleton": "react-typography_1-3-2_co-heading--skeleton",
  "co-heading--animated-skeleton": "react-typography_1-3-2_co-heading--animated-skeleton",
  "wave": "react-typography_1-3-2_wave",
  "co-text--skeleton": "react-typography_1-3-2_co-text--skeleton",
  "co-text--animated-skeleton": "react-typography_1-3-2_co-text--animated-skeleton"
};
styleInject(css);

const classModifiers$1 = {
  1: "co-heading--1",
  2: "co-heading--2",
  3: "co-heading--3",
  4: "co-heading--4",
  5: "co-heading--5",
  6: "co-heading--6",
  static: "co-heading--skeleton",
  animated: "co-heading--animated-skeleton"
};

function getSkeletonAttributes$1(options) {
  switch (options) {
    case "static":
    case "animated":
      return {
        type: options
      };

    default:
      return options;
  }
}

const Skeleton$1 = ({
  options,
  level,
  forwardedRef,
  ...props
}) => {
  const {
    type,
    width
  } = getSkeletonAttributes$1(options);
  const Tag = `h${level}`;
  const classStyles = cc__default['default']([styles["co-heading"], styles[classModifiers$1[level]], styles[classModifiers$1[type]]]);
  return /*#__PURE__*/React__default['default'].createElement(Tag, _extends({}, props, {
    ref: forwardedRef,
    className: classStyles,
    style: {
      width
    }
  }));
};

const Heading = ({
  className = "",
  forwardedRef,
  style,
  level,
  asLevel,
  skeleton,
  truncated,
  color,
  ...props
}) => {
  if (skeleton) {
    return /*#__PURE__*/React__default['default'].createElement(Skeleton$1, _extends({
      forwardedRef: forwardedRef,
      options: skeleton,
      level: asLevel || level
    }, props));
  }

  const Tag = `h${level}`;
  const classStyles = cc__default['default']([styles["co-heading"], styles[classModifiers$1[asLevel || level]], {
    [styles["co-heading--truncated"]]: truncated
  }, className]);
  return /*#__PURE__*/React__default['default'].createElement(Tag, _extends({
    className: classStyles,
    ref: forwardedRef,
    style: {
      color,
      ...style
    }
  }, props, {
    "data-co-name": "Heading",
    "data-co-version": "1.3.2",
    "data-co-project": "cobalt"
  }));
};

const classNames = {
  smallSize: "co-text--small",
  mediumSize: "co-text--medium",
  lightWeight: "co-text--weight-light",
  regularWeight: "co-text--weight-regular",
  mediumWeight: "co-text--weight-medium",
  inheritWeight: "co-text--weight-inherit",
  truncated: "co-text--truncated",
  static: "co-text--skeleton",
  animated: "co-text--animated-skeleton"
};

function getSizeKey(size) {
  switch (size) {
    case "medium":
      return "mediumSize";

    case "small":
      return "smallSize";
  }
}

function getWeightKey(weight) {
  switch (weight) {
    case "medium":
      return "mediumWeight";

    case "regular":
      return "regularWeight";

    case "light":
      return "lightWeight";

    case "inherit":
      return "inheritWeight";
  }
}

function getSkeletonAttributes(options) {
  switch (options) {
    case "static":
    case "animated":
      return {
        type: options
      };

    default:
      return options;
  }
}

const Skeleton = ({
  options,
  size,
  inline,
  forwardedRef,
  ...props
}) => {
  const {
    type,
    lines = 1,
    width
  } = getSkeletonAttributes(options);
  const Tag = inline ? "span" : "p";
  const classStyles = cc__default['default']([styles["co-text"], styles[classNames[getSizeKey(size)]], styles[classNames[type]]]);

  const SkeletonLine = () => /*#__PURE__*/React__default['default'].createElement("span", {
    className: classStyles,
    style: {
      display: "block",
      width
    }
  });

  if (lines > 1 && !inline) {
    return /*#__PURE__*/React__default['default'].createElement(Tag, _extends({}, props, {
      ref: forwardedRef,
      style: {
        width
      }
    }), new Array(lines).fill(0).map((_, index) => /*#__PURE__*/React__default['default'].createElement(SkeletonLine, {
      key: index
    })));
  }

  return /*#__PURE__*/React__default['default'].createElement(Tag, _extends({}, props, {
    className: classStyles,
    style: {
      width
    }
  }));
};

const Text = ({
  className = "",
  forwardedRef,
  style,
  color,
  inline,
  size = "medium",
  skeleton,
  weight = "regular",
  truncated,
  ...props
}) => {
  if (skeleton) {
    return /*#__PURE__*/React__default['default'].createElement(Skeleton, _extends({
      options: skeleton,
      size: size,
      inline: inline
    }, props));
  }

  const Tag = inline ? "span" : "p";
  const classStyles = [styles["co-text"], styles[classNames[getSizeKey(size)]], styles[classNames[getWeightKey(weight)]], {
    [styles[classNames["truncated"]]]: truncated
  }, className];
  return /*#__PURE__*/React__default['default'].createElement(Tag, _extends({
    className: cc__default['default'](classStyles),
    ref: forwardedRef,
    style: {
      color,
      ...style
    }
  }, props, {
    "data-co-name": "Text",
    "data-co-version": "1.3.2",
    "data-co-project": "cobalt"
  }));
};

const classModifiers = {
  yellow: "co-mark--yellow",
  "light-yellow": "co-mark--light-yellow"
};

const getModifierClass = modifier => modifier && styles[classModifiers[modifier]];

const Mark = ({
  className = "",
  forwardedRef,
  color = "yellow",
  ...props
}) => {
  const classStyles = [styles["co-mark"], getModifierClass(color), className];
  return /*#__PURE__*/React__default['default'].createElement("mark", _extends({
    className: cc__default['default'](classStyles),
    ref: forwardedRef
  }, props, {
    "data-co-name": "Mark",
    "data-co-version": "1.3.2",
    "data-co-project": "cobalt"
  }));
};

exports.Heading = Heading;
exports.Mark = Mark;
exports.Text = Text;
